// extracted by mini-css-extract-plugin
export var phone = "_20-0";
export var phoneDragging = "_20-1";